import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col"
  }, [_c("div", {
    staticClass: "box1 flex-col"
  }, [_vm.allData["1"] && _vm.allData["1"].length > 0 ? _c("div", [_c("div", {
    staticClass: "group15 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toChange("Community");
      }
    }
  }, [_c("span", {
    staticClass: "word8"
  }, [_vm._v(_vm._s(_vm.$t("Community")))]), _c("img", {
    staticClass: "box2 flex-col",
    attrs: {
      src: require("../../../assets/images/search_right.png")
    }
  })]), _c("div", {
    staticClass: "group16 flex-col"
  }), _vm._l(_vm.allData["1"], function (item) {
    return _c("div", {
      key: item,
      staticClass: "group17 flex-row justify-between",
      on: {
        click: function click($event) {
          return _vm.toDetail("club", item.threadId);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
      staticClass: "section1 flex-col"
    }, [_c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }), item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e()], 1) : _vm._e(), _c("div", {
      staticClass: "section2 flex-col justify-between"
    }, [_c("div", {
      staticClass: "box4"
    }, [_c("span", {
      class: [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? "word10" : "word11"],
      domProps: {
        innerHTML: _vm._s(item.content.text)
      }
    })])])]);
  })], 2) : _vm._e(), _vm.allData["2"] && _vm.allData["2"].length > 0 ? _c("div", [_c("div", {
    staticClass: "group15 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toChange("Activity");
      }
    }
  }, [_c("span", {
    staticClass: "word8"
  }, [_vm._v(_vm._s(_vm.$t("Activity")))]), _c("img", {
    staticClass: "box2 flex-col",
    attrs: {
      src: require("../../../assets/images/search_right.png")
    }
  })]), _c("div", {
    staticClass: "group16 flex-col"
  }), _vm._l(_vm.allData["2"], function (item) {
    return _c("div", {
      key: item,
      staticClass: "group17 flex-row justify-between",
      on: {
        click: function click($event) {
          return _vm.toDetail("activity", item.threadId);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
      staticClass: "section1 flex-col"
    }, [_c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }), item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e()], 1) : _vm._e(), _c("div", {
      staticClass: "section2 flex-col justify-between"
    }, [_c("span", {
      class: [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? "word9" : "word12"]
    }, [_vm._v(_vm._s(item.title))]), _c("div", {
      staticClass: "box4"
    }, [_c("span", {
      class: [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? "word10" : "word11"],
      domProps: {
        innerHTML: _vm._s(item.content.text)
      }
    })])])]);
  })], 2) : _vm._e(), _vm.allData["4"] && _vm.allData["4"].length > 0 ? _c("div", [_c("div", {
    staticClass: "group15 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toChange("News");
      }
    }
  }, [_c("span", {
    staticClass: "word8"
  }, [_vm._v(_vm._s(_vm.$t("News")))]), _c("img", {
    staticClass: "box2 flex-col",
    attrs: {
      src: require("../../../assets/images/search_right.png")
    }
  })]), _c("div", {
    staticClass: "group16 flex-col"
  }), _vm._l(_vm.allData["4"], function (item) {
    return _c("div", {
      key: item,
      staticClass: "group17 flex-row justify-between",
      on: {
        click: function click($event) {
          return _vm.toDetail("news", item.threadId);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
      staticClass: "section1 flex-col"
    }, [_c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }), item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e()], 1) : _vm._e(), _c("div", {
      staticClass: "section2 flex-col justify-between"
    }, [item.title ? _c("div", {
      staticClass: "box3"
    }, [_c("span", {
      class: [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? "word9" : "word12"]
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e(), _c("div", {
      staticClass: "box4"
    }, [_c("span", {
      class: [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? "word10" : "word11"],
      domProps: {
        innerHTML: _vm._s(item.content.text)
      }
    })])])]);
  })], 2) : _vm._e(), !_vm.allData["1"] && !_vm.allData["2"] && !_vm.allData["4"] ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.nodata,
      expression: "nodata"
    }],
    staticClass: "noData"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("NoData")))])]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };